<main class="mb-4">
  <div class="row">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Title' | translate}}</h2>
    </div>
  </div>

  <div class="row">

    <!-- Estava a receber uma pensão de aposentação/reforma plea CGA à data do óbito? -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isHadPensionCGABeforeDeathDisabled()">
          <label for="CGAPension"><span class="mandatory">*</span>{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.CGAPension' | translate}}</label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.hadPensionCGABeforeDeath?.toString()" [radioLabel]="CGAPension">
              <input type="radio"
                     [(ngModel)]="cardData.hadPensionCGABeforeDeath"
                     name="CGAPension"
                     #CGAPension="ngModel"
                     [value]="domain.value"
                     (change)="isPensionUnified();resetCategoriaProfissional();"
                     [disabled]="isHadPensionCGABeforeDeathDisabled()"
                     required>
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Estava a efetuar descontos para a CGA à data do óbito -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="true">
          <label for="CGARelationship"
                 [class.disabled]="cardData.hadPensionCGABeforeDeath?.toString()!='false'">
            <span class="mandatory" *ngIf="cardData.hadPensionCGABeforeDeath?.toString()=='false'">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.CGARelationship' | translate}}
          </label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.hadDiscountsCGABeforeDeath?.toString()" [radioLabel]="CGARelationship">
              <input type="radio"
                     [(ngModel)]="cardData.hadDiscountsCGABeforeDeath"
                     name="CGARelationship"
                     #CGARelationship="ngModel"
                     [value]="domain.value"
                     [disabled]="true"
                     [required]="cardData.hadPensionCGABeforeDeath?.toString()=='false'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Tipo de subscritor -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hadPensionCGABeforeDeath?.toString() != 'false'">
          <label for="SubscriberType">
            <span *ngIf="cardData.hadPensionCGABeforeDeath?.toString() == 'false'" class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.SubscriberType' | translate}}
            <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação"
                  tooltip="{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.SubscriberTypeTooltip' | translate}}"></span>
          </label>
          <br />
          <div class="btn-group btn-group-toggle w-100">
            <label *ngFor="let domain of subscriberTypes;" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.code==cardData.subscriberType" [radioLabel]="subscriberType">
              <input type="radio"
                     [(ngModel)]="cardData.subscriberType"
                     #subscriberType="ngModel"
                     name="subscriberType"
                     [value]="domain.code"
                     (ngModelChange)="subscriberTypeCodeChanged()"
                     [required]="cardData.hadPensionCGABeforeDeath?.toString() == 'false'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>

  @if(hasProfessionalCategoryCode){
  <div class="row">
    <!--Categoria profissional-->

    <div class="col-sm-8">
      <div class="form-group">
        <label for="professionalCategoryCode" [class.disabled]="cardData.subscriberType == null || cardData.subscriberType == undefined">
          <span class="mandatory" *ngIf="!(cardData.subscriberType == null || cardData.subscriberType == undefined)">*</span>
          {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.ProfessionalCategory' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="cardData.professionalCategoryCode"
                name="professionalCategoryCode"
                #professionalCategoryCode="ngModel"
                [disabled]="cardData.subscriberType == null || cardData.subscriberType == undefined"
                [required]="!(cardData.subscriberType == null || cardData.subscriberType == undefined)"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of dropListProfessionalC" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="professionalCategoryCode"></validation-message>
      </div>
    </div>


  </div>
  }
  <div class="row">

    <!-- Era pensionista no regime Segurança social? -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset>
          <label for="SSPensionist"><span class="mandatory">*</span>{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.SSPensionist' | translate}}</label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.SSPensionist?.toString()" [radioLabel]="SSPensionist">
              <input type="radio"
                     [(ngModel)]="cardData.SSPensionist"
                     name="SSPensionist"
                     #SSPensionist="ngModel"
                     [value]="domain.value"
                     (change)="onSSPensionistChanged()"
                     required>
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>

      </div>
    </div>

    <!-- Efetuou descontos para a segurança social? -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.SSPensionist?.toString() == 'true'">
          <label for="SSDiscounts">
            <span *ngIf="cardData.SSPensionist?.toString() == 'false'" class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.SSDiscounts' | translate}}
          </label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.SSDiscounts?.toString()" [radioLabel]="SSDiscounts">
              <input type="radio"
                     [(ngModel)]="cardData.SSDiscounts"
                     name="SSDiscounts"
                     (change)="isPensionUnified()"
                     #SSDiscounts="ngModel"
                     [value]="domain.value"
                     [required]="cardData.SSPensionist?.toString() == 'false'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>

      </div>
    </div>



    <!-- Número de beneficiário -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('beneficiaryNumber') || !( this.cardData.SSDiscounts?.toString() == 'true' || this.cardData.SSPensionist?.toString() == 'true')">
          <label for="beneficiaryNumber" [class.disabled]="isFieldDisabled('beneficiaryNumber') || !( this.cardData.SSDiscounts?.toString() == 'true' || this.cardData.SSPensionist?.toString() == 'true')">
            <span *ngIf="(this.cardData.SSDiscounts?.toString() == 'true' || this.cardData.SSPensionist?.toString() == 'true')" class="mandatory">*</span>{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.BeneficiaryNumber' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right"
                   type="text"
                   [maxLength]="11"
                   [(ngModel)]="cardData.beneficiaryNumber"
                   #beneficiaryNumber="ngModel"
                   mask="99999999999"
                   name="beneficiaryNumber"
                   messageFieldType="string"
                   [required]="!isFieldDisabled('beneficiaryNumber') && (this.cardData.SSDiscounts?.toString() == 'true' || this.cardData.SSPensionist?.toString() == 'true')">
            <validation-message [control]="beneficiaryNumber"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

  </div>

  <div class="row">

    <!-- Os habilitandos pretendem benficiar de pensão unificada? -->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hadPensionCGABeforeDeath?.toString() != 'false' || cardData.SSPensionist?.toString() != 'false' || cardData.SSDiscounts?.toString() != 'true'">
          <label for="UnifiedPension">
            <span *ngIf="cardData.hadPensionCGABeforeDeath?.toString() == 'false' && cardData.SSPensionist?.toString() == 'false' && cardData.SSDiscounts?.toString() == 'true'" class="mandatory">*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.UnifiedPension' | translate}}
          </label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.unifiedPension?.toString()" [radioLabel]="unifiedPension">
              <input type="radio"
                     [(ngModel)]="cardData.unifiedPension"
                     name="unifiedPension"
                     #unifiedPension="ngModel"
                     [value]="domain.value"
                     [required]="cardData.hadPensionCGABeforeDeath?.toString() == 'false' && cardData.SSPensionist?.toString() == 'false'  &&  cardData.SSDiscounts?.toString() == 'true'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!-- Ultimo serviço funções -->
    <div class="col-sm-8">
      <div class="form-group">
        <fieldset [disabled]="true">
          <label for="lastWorkPlace" class="disable">
            <span>*</span>
            {{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.LastWorkPlace' | translate}}
          </label>
          <br />
          <div class="position-relative">
            <input class="form-control input-right"
                   type="text"
                   [(ngModel)]="cardData.lastService"
                   #lastWorkPlace="ngModel"
                   name="lastWorkPlace"
                   messageFieldType="string">
            <validation-message [control]="lastWorkPlace"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

  </div>

  <div class="row">

    <!-- Trabalhou no estrangeiro -->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkedAbroad">
          <span class="mandatory">*</span>{{'PrestacoesMorte.StepDeceased.Cards.ProfessionalCategory.Fields.WorkedAbroad' | translate}}
          <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.WorkedAbroad' | translate}}"></span>
        </label>

        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle"
                   [class.active]="domain.value==cardData.hasWorkedAbroad?.toString()" [radioLabel]="hasWorkedAbroad">
              <input type="radio"
                     [(ngModel)]="cardData.hasWorkedAbroad"
                     name="hasWorkedAbroad"
                     #hasWorkedAbroad="ngModel"
                     [value]="domain.value"
                     (change)="hasWorkedAbroadChanged()"
                     required>
              {{domain.description}}
            </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>


  </div>
  <span></span>

  <div class="col-sm-12 text-end">
    <button [disabled]="cardData.hasWorkedAbroad?.toString() == 'false' || !cardData.hasWorkedAbroad"
            (click)="expandNewWorkAbroad=!expandNewWorkAbroad"
            [ngClass]="!expandNewWorkAbroad ? '' : 'disabled'"
            aria-label="Nova entrada"
            type="button"
            class="btn btn-link">
      <span class="icon-add"></span> <span>{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</span>
    </button>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewWorkAbroad" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewWorkAbroad=!expandNewWorkAbroad"
            [disabled]="isSubmited || cardData.hasWorkedAbroad?.toString() == 'false' || !cardData.hasWorkedAbroad">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</h3>
    <work-abroad-table-edit-pm [isSubmited]="isSubmited" [itemList]="cardData.workedAbroadList" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit-pm>
  </div>
  <table class="table table-striped">
    <thead [class.disabled]="cardData.hasWorkedAbroad?.toString() == 'false' || !cardData.hasWorkedAbroad">
      <tr>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.Country' | translate}}</th>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.PayedTaxes' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.workedAbroadList; let i = index">
        <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td>{{tableItem.countryAbroadCode | commonData : countries : 'code' : 'desc'}}</td>
          <td>{{tableItem.hasDiscountsAbroad?.toString() | commonData : yesNo : 'value' : 'desc'}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar"
                    [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic"
                    *ngIf="!isSubmited">
              <span class="p-1"
                    [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-edit'"></span>
            </button>
            <button type="button" class="btn-icon" aria-label="Apagar" *ngIf="!isSubmited">
              <span class="icon-trash p-1" (click)="removeFromList(cardData.workedAbroadList, i,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="3" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <work-abroad-table-edit-pm [isSubmited]="isSubmited" [itemList]="cardData.workedAbroadList" [editIndex]="i" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit-pm>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
  <input hidden value="cardData?.hasWorkedAbroad?.length" [class.ng-invalid]="cardData?.hasWorkedAbroad?.toString() == 'true' && cardData?.workedAbroadList?.length < 1" />
  <validation-message *ngIf="cardData?.hasWorkedAbroad?.toString() == 'true' && cardData?.workedAbroadList?.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>
</main>
